import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import { TabsHorizontal } from '../../core/TabsHorizontal';
import Icon from '../../core/Icon';
import { Paginator } from '../../core/Paginator';
import SearchComponent from '../../core/Search';

const SearchAnimation = keyframes`
  0%{
    transform: translateY(-20%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
`;

const SearchAnimationInverse = keyframes`
  0%{
    transform: translateY(0%);
    opacity: 1;
  }
  100% {
    transform: translateY(-20%);
    opacity: 0;
  }
`;

const StyledSearchModal = styled.div`
  background-color: rgba(255, 255, 255, 0.99);
  height: 100%;
  left: 0;
  max-height: 100vh;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  animation-name: ${props =>
    props.mount ? SearchAnimation : SearchAnimationInverse};
  animation-duration: 0.35s;
  animation-timing-function: ease;
`;

const WrapperLogo = styled.div`
  display: none;
  margin-bottom: ${rem('50px')};
  max-height: ${rem('60px')};

  ${mediaqueries.greaterThan('mobile')`
    display: block;
    max-width: ${rem('100px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('106px')};
  `};
`;

const IconLogo = styled(Icon)`
  width: 100%;
`;

const MainSearch = styled.div`
  height: 100%;
  margin: auto;
  max-width: ${rem('1336px')};
  padding: 4rem ${rem('10px')} ${rem('10px')} ${rem('10px')};
  position: relative;

  ${mediaqueries.greaterThan('mobile')`
    padding: 1rem ${rem('25px')} ${rem('25px')} ${rem('25px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    padding: 3rem ${rem('70px')} ${rem('25px')} ${rem('70px')};
  `};
`;

const ItemResult = styled.div`
  margin-bottom: ${rem('7px')};
`;

const FormSearch = styled(SearchComponent)`
  margin-bottom: ${rem('20px')};
`;

const TabsSearch = styled(TabsHorizontal)`
  margin-bottom: ${rem('10px')};

  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: ${rem('20px')};
  `};
`;

const SearchPaginator = styled(Paginator)`
  margin-top: ${rem('30px')};
`;

const Help = styled.div`
  margin-top: 2rem;
  text-align: center;

  ${mediaqueries.greaterThan('desktop')`
    margin-top: 0;
    text-align: right;
  `};
`;

const HelpParagraph = styled.p`
  font-size: ${rem('12px')};
  line-height: 1;
  margin: 0 0 ${rem('5px')} 0;
`;

const HelpLink = styled.a`
  font-family: ${props => props.theme.fonts.medium};
`;

const IconClose = styled(Icon)`
  position: absolute;
  top: 0;
  right: 0;
  margin: 1.25rem 1rem 0 0;

  ${mediaqueries.greaterThan('mobile')`
    margin: 2rem 2rem 0 0;
  `};
`;

export {
  StyledSearchModal,
  WrapperLogo,
  IconLogo,
  MainSearch,
  ItemResult,
  FormSearch,
  TabsSearch,
  Help,
  HelpParagraph,
  HelpLink,
  SearchPaginator,
  IconClose
};
